import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";
import Constants from "../../services/constants";
import VehicleSearchTable from "./VehicleSearchTable";

const VehicleSearch = () => {
    const history = useNavigate();
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState("");
    const [vehicleSearchUsers, setVehicleSearchUsers] = useState([]);

    useEffect(() => {
        const fetchVehicleSearchUsers = async () => {
            setLoading(true);
            const res = await api("get", Constants.END_POINT.VEHICLE_SEARCH_USERS);
            if (res.success && Array.isArray(res.data)) {
                setVehicleSearchUsers(res.data);
            }
            setLoading(false);
        };

        fetchVehicleSearchUsers();
    }, []);

    const filteredUsers = vehicleSearchUsers
        .filter((item) => {
            const query = search.trim().toLowerCase();
            if (!query) return true;

            return (
                item?.firstName?.toLowerCase().includes(query) ||
                item?.vehicleNumber?.toLowerCase().includes(query) ||
                item?.mobile?.includes(search.trim())
            );
        })
        .map((item) => ({
            ...item,
            time: item.time ? new Date(item.time) : null,
        }));

    return (
        <VehicleSearchTable
            heading="Vehicle Search Users"
            vehicleSearchUsers={filteredUsers}
            loading={loading}
            history={history}
            search={search}
            setSearch={setSearch}
        />
    );
};

export default VehicleSearch;
